const DATE_OF_BIRTH = 'traveler-date-of-birth-form';
const FIRST_NAME = 'traveler-firstName';
const FIRST_TRAVELER = 'traveler-section-0';
const GENDER = 'traveler-gender';
const LAST_NAME = 'traveler-lastName';
const TAX_ID_INPUT = 'taxIdInput';
const TRAVELER_FORM_SECTION_NAME = 'traveler-section';
export const travelerInputs = {
  DATE_OF_BIRTH,
  FIRST_NAME,
  FIRST_TRAVELER,
  GENDER,
  LAST_NAME,
  TAX_ID_INPUT,
  TRAVELER_FORM_SECTION_NAME
};
//# sourceMappingURL=travelerInputs.js.map